import {Fragment, useCallback, useState} from "react";
import HelpIcon from "@mui/icons-material/Help";
import {Button, DialogActions, DialogContent, Grid, IconButton, Tooltip} from "@mui/material";
import {useTranslation} from "react-i18next";
import AlertDialog from "../../alert-dialog";
import AppInfo from "../../app-info";
import {HEADER_BUTTON_VIEW_MODE_ICONTEXT, HEADER_BUTTON_VIEW_MODE_TEXT} from "../utils";

const InfoButton = ({hub, viewMode}) => {
  const {t} = useTranslation();
  const [isOpen, setisOpen] = useState(false);

  const onOpen = useCallback(() => {
    setisOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setisOpen(false);
  }, []);

  return (
    <Fragment>
      <Grid className="info-btn">
        <Tooltip title={t("components.header.actions.info.title")}>
          {viewMode === HEADER_BUTTON_VIEW_MODE_TEXT ? (
            <Button onClick={onOpen} aria-label={t("components.header.actions.info.ariaLabel")} color="inherit">
              {t("components.header.actions.info.label")}
            </Button>
          ) : viewMode === HEADER_BUTTON_VIEW_MODE_ICONTEXT ? (
            <Button
              onClick={onOpen}
              aria-label={t("components.header.actions.info.ariaLabel")}
              startIcon={<HelpIcon />}
            >
              {t("components.header.actions.info.label")}
            </Button>
          ) : (
            <IconButton onClick={onOpen} color="inherit" aria-label={t("components.header.actions.info.ariaLabel")}>
              <HelpIcon />
            </IconButton>
          )}
        </Tooltip>
      </Grid>
      <AlertDialog open={isOpen} onClose={onClose}>
        <DialogContent>
          <AppInfo hub={hub} />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>{t("commons.confirm.close")}</Button>
        </DialogActions>
      </AlertDialog>
    </Fragment>
  );
};

export default InfoButton;
